var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MAPIT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 326,
    rx: 204,
    ry: 45,
    fill: "none",
    stroke: "#0f66e8",
    strokeWidth: 17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 138 L128 324 L178 324 L178 226 L256 290 L334 226 L334 324 L384 324 L384 138 L256 246 Z",
    fill: "#102033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapitLogo);
export default __webpack_public_path__ + "static/media/mapit-logo.35be4eda218c433c7b6c1296758049b7.svg";
export { ForwardRef as ReactComponent };